import { X, ArrowUpRight } from "lucide-react";
import { toast } from "sonner";
import { errorText } from "@/lib/api";

export const Modal = ({ title, close, children, wide }) => (
  <div className="modal-backdrop" data-testid="modal">
    <div className={`modal ${wide ? "modal-wide" : ""}`}>
      <div className="modal-head">
        <h3>{title}</h3>
        <button onClick={close} data-testid="modal-close-button"><X size={19} /></button>
      </div>
      {children}
    </div>
  </div>
);

const FieldInput = ({ f, id }) => f.type === "select"
  ? <select name={f.name} defaultValue={f.defaultValue} data-testid={id}>{f.options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}</select>
  : <><input name={f.name} type={f.type || "text"} step={f.step} min={f.min} max={f.max} maxLength={f.maxLength} defaultValue={f.defaultValue} required={f.required} list={f.suggestions ? `${id}-list` : undefined} data-testid={id} />
    {f.suggestions && <datalist id={`${id}-list`}>{f.suggestions.map(s => <option key={s} value={s} />)}</datalist>}</>;

export const FormModal = ({ title, fields, onSubmit, close, testId, submitLabel = "Kaydet" }) => {
  const submit = async (e) => {
    e.preventDefault();
    const data = Object.fromEntries(new FormData(e.currentTarget));
    fields.filter(f => f.type === "number").forEach(f => { data[f.name] = Number(data[f.name] || 0); });
    try { await onSubmit(data); close(); } catch (err) { toast.dismiss(); toast.error(errorText(err)); }
  };
  return (
    <Modal title={title} close={close}>
      <form className="modal-form" onSubmit={submit} data-testid={`${testId}-form`}>
        {fields.map(f => <label key={f.name}>{f.label}<FieldInput f={f} id={`${testId}-${f.name}-input`} /></label>)}
        <button className="primary-btn" data-testid={`${testId}-submit-button`}>{submitLabel} <ArrowUpRight size={17} /></button>
      </form>
    </Modal>
  );
};

export const PanelHead = ({ title, sub, children }) => (
  <div className="panel-head"><div><h2>{title}</h2>{sub && <p>{sub}</p>}</div>{children && <div className="panel-tools">{children}</div>}</div>
);

export const EmptyRow = ({ cols, text = "Henüz kayıt yok." }) => <tr><td colSpan={cols} className="empty-row">{text}</td></tr>;
